var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38.719,
    height: 73.716,
    viewBox: "0 0 38.719 73.716",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 2.508,
    y1: -0.009,
    x2: 2.508,
    y2: 3.548,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.031,
    stopColor: "#bfa168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.063,
    stopColor: "#c0a269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#c1a369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.125,
    stopColor: "#c2a46a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#c3a46b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.188,
    stopColor: "#c4a56b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.219,
    stopColor: "#c5a66c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#c6a76c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.281,
    stopColor: "#c7a76d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.313,
    stopColor: "#c8a86e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.344,
    stopColor: "#c9a96e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.375,
    stopColor: "#caa96f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.406,
    stopColor: "#cbaa6f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.438,
    stopColor: "#ccab70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469,
    stopColor: "#cdac71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#cead71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.531,
    stopColor: "#cead72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.563,
    stopColor: "#cfae72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.594,
    stopColor: "#d0af73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#d1af74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.656,
    stopColor: "#d2b074"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.688,
    stopColor: "#d3b175"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.719,
    stopColor: "#d4b275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#d5b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#d6b376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.813,
    stopColor: "#d7b477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.844,
    stopColor: "#d8b578"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.875,
    stopColor: "#d9b678"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.906,
    stopColor: "#dab679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.938,
    stopColor: "#dbb779"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#dcb87a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddb87b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M35,40.961H67.6v73.716H35Zm0,0",
    transform: "translate(-35 -40.961)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 32.778,
    height: 75.489,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M.039.961H32.6V74.677H.039Zm0,0",
    transform: "translate(-0.039 -0.961)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M.246,1H32.605V74.5H.246Zm0,0",
    transform: "translate(-0.246 -1)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M29.8,37.31a4.969,4.969,0,0,0-1.878-1.04,6.909,6.909,0,0,0-2.181-.26,11.523,11.523,0,0,0-2.235.314c-.136.027-.26.062-.392.1s-.283.081-.427.128a10.7,10.7,0,0,0-1.323.508A12.052,12.052,0,0,0,17.7,39.719a17.915,17.915,0,0,0-1.471,1.773c-.147.2-.287.4-.423.605s-.287.423-.423.644-.295.458-.431.695a22.545,22.545,0,0,0-1.924,4.225A26.484,26.484,0,0,0,11.957,52.2a31.922,31.922,0,0,0-.384,4.788v0c.085-.093.171-.19.256-.287.043-.046.081-.1.12-.147a8.344,8.344,0,0,0,.508-.664c.128-.182.248-.372.365-.574.023-.039.05-.093.074-.132.093-.159.186-.322.272-.489.019-.043.039-.089.058-.128.093-.179.178-.365.26-.551.015-.035.027-.07.039-.1a2.292,2.292,0,0,0,.1-.244c.136-.986.314-1.967.528-2.945a27.883,27.883,0,0,1,.939-3.325c.043-.113.078-.225.113-.334.144-.376.287-.753.446-1.129A24,24,0,0,1,16.768,43.6c.31-.559.636-1.11.986-1.637s.718-1.051,1.129-1.548A13.705,13.705,0,0,1,20.2,39.005a10.469,10.469,0,0,1,1.544-1.187,7.821,7.821,0,0,1,.92-.508c.144-.07.283-.132.427-.2a8.528,8.528,0,0,1,2.312-.617,4.613,4.613,0,0,1,1.28.175,4.98,4.98,0,0,1,.6.206l.57.237a7.509,7.509,0,0,1,1.09.6c.167.124.341.244.5.388a4.978,4.978,0,0,1,.473.435,3.862,3.862,0,0,1,.714,1.055c.093.19.167.392.248.582s.136.4.2.594A14.259,14.259,0,0,1,31.57,43.2a14.738,14.738,0,0,1-.264,4.916,19.1,19.1,0,0,1-.691,2.359,22.692,22.692,0,0,1-.993,2.239c-.1.178-.19.365-.283.543l-.3.528c-.21.357-.427.7-.64,1.044l-.349.5c-.116.171-.225.338-.357.5-.256.322-.5.648-.776.951a16.2,16.2,0,0,1-3.709,3.186,17,17,0,0,1-4.47,1.944l-.586.155c-.1.023-.2.05-.295.07l-.3.062-.6.116c-.2.043-.4.062-.6.1l-.6.089c-.209.023-.415.043-.625.054a7.567,7.567,0,0,1-1.257-.019l-.415-.035-.043-.419c-.085-.9-.136-1.789-.151-2.689-.1.054-.2.113-.3.163-.012,0-.023.015-.035.019-.407.21-.819.407-1.242.59.043.469.093.935.151,1.4l.1.733-.7-.225A10.149,10.149,0,0,1,9.1,61.09a.637.637,0,0,1-.054-.039c-.163-.1-.326-.209-.481-.318a9.881,9.881,0,0,1-.892-.718c-.116-.109-.225-.213-.338-.326a.585.585,0,0,1-.07-.07,11.316,11.316,0,0,1-1.459-1.847A15.409,15.409,0,0,1,4.729,55.7l-.217-.535c-.07-.178-.132-.365-.2-.547-.132-.365-.248-.733-.353-1.106a20.434,20.434,0,0,1-.512-2.258,22.649,22.649,0,0,1-.275-4.609,26.489,26.489,0,0,1,.609-4.563,24.683,24.683,0,0,1,1.377-4.4c.14-.357.314-.7.473-1.051.089-.175.178-.341.264-.516l.132-.256.144-.248A18.216,18.216,0,0,1,7.417,33.67a19.627,19.627,0,0,1,1.471-1.785,20.211,20.211,0,0,1,1.68-1.583l.31-.26.3.272a7.42,7.42,0,0,0,3.174,1.68,6.9,6.9,0,0,0,1.051.175c.144.015.279.023.423.031.109,0,.217.008.33.008A10.617,10.617,0,0,0,18,32.06c.625-.093,1.238-.209,1.839-.361a9.854,9.854,0,0,0,1.734-.605,6.179,6.179,0,0,0,.792-.427,4.239,4.239,0,0,0,.489-.369c.074-.058.14-.113.209-.178s.148-.14.217-.209a3.968,3.968,0,0,0,.861-1.141,1.676,1.676,0,0,0,.12-.365,1.2,1.2,0,0,0,.027-.353,2,2,0,0,0-.225-.733,2.319,2.319,0,0,0-.5-.594,2.125,2.125,0,0,0-.264-.182v.764a1.474,1.474,0,0,1,.268.6,1.286,1.286,0,0,1,.027.388,1.893,1.893,0,0,1-.062.341,1.635,1.635,0,0,1-.1.295l-.027.081-.039.07-.074.148v0a3.023,3.023,0,0,1-.423.57,2.911,2.911,0,0,1-.357.338,5.749,5.749,0,0,1-1.994,1,12.8,12.8,0,0,1-2.091.419,9.349,9.349,0,0,1-2.161.023c-.14-.016-.287-.043-.431-.066-.035-.008-.074-.012-.109-.019-.1-.023-.209-.043-.31-.07-.074-.019-.151-.035-.233-.062A5.636,5.636,0,0,1,13.2,30.337a6.166,6.166,0,0,1-.8-.8l-.369-.438.489-.3a17.383,17.383,0,0,1,2.887-1.4v-.473a20.52,20.52,0,0,0-3.294,1.331l-.431.221-.209-.438a8.472,8.472,0,0,1-.737-2.5c-.058-.427-.093-.846-.113-1.269s-.023-.85-.012-1.273l.023-.516.5.062a19.357,19.357,0,0,0,3.55.05c.241-.015.481-.039.722-.062.144-.015.279-.027.419-.047.213-.023.427-.047.644-.074l.885-.128.881-.163a21.288,21.288,0,0,0,4.644-1.467c.14-.066.283-.128.419-.194a13.676,13.676,0,0,0,1.537-.881,12.8,12.8,0,0,0,2.669-2.293c.186-.229.372-.458.563-.687.171-.241.341-.473.512-.718.151-.252.31-.5.458-.753s.275-.52.4-.788a7.2,7.2,0,0,0,.745-3.333,4.988,4.988,0,0,0-.357-1.63,4.324,4.324,0,0,0-.376-.745l-.112-.178-.124-.171c-.039-.054-.078-.109-.124-.167l-.136-.151a4.22,4.22,0,0,0-1.3-.993,5.353,5.353,0,0,0-1.606-.481,9.124,9.124,0,0,0-1.727-.07c-.062,0-.116.012-.175.012a2.844,2.844,0,0,0-.229.446,5.368,5.368,0,0,1,1.711.252,3.808,3.808,0,0,1,1.544.931,4.328,4.328,0,0,1,.954,1.513l.012.027,0,.031a7.954,7.954,0,0,1,.2,1.222,5.336,5.336,0,0,1-.031,1.269,7.565,7.565,0,0,1-.749,2.355,12.585,12.585,0,0,1-1.284,2.033,12.426,12.426,0,0,1-1.614,1.765,12.235,12.235,0,0,1-1.377,1.071c-.144.1-.279.194-.419.283-.043.027-.078.058-.116.082a14.4,14.4,0,0,1-2.13,1.071,17.338,17.338,0,0,1-3.442.966c-.062.019-.128.035-.2.05a10.063,10.063,0,0,1-1.168.178q-.2.023-.419.035c-1.688.132-3.535.062-3.535.062-.241,0-.477-.031-.71-.047L10.677,22l.054-.5a20.081,20.081,0,0,1,.644-3.209,19.2,19.2,0,0,1,1.2-3.042,20.724,20.724,0,0,1,1.692-2.786A17.072,17.072,0,0,1,15.4,11.05c-.012-.528-.031-1.013-.066-1.451A15.673,15.673,0,0,0,13.3,11.43a19.231,19.231,0,0,0-2.181,2.832A16.916,16.916,0,0,0,8.667,20.92l-.081.574-.539-.19a11.161,11.161,0,0,1-3.112-1.649,9.288,9.288,0,0,1-2.351-2.669A10.908,10.908,0,0,1,1.26,13.7c-.058-.291-.116-.586-.151-.885s-.066-.594-.07-.888c-.019-.295,0-.6,0-.892l.035-.454c.012-.147.035-.295.058-.442A9.885,9.885,0,0,1,2.284,6.766a12.793,12.793,0,0,1,2.15-2.794A10.234,10.234,0,0,1,7.351,1.978a11.388,11.388,0,0,1,2.8-.842.039.039,0,0,0-.019-.016.188.188,0,0,0-.043-.027.284.284,0,0,0-.12-.016,10.779,10.779,0,0,0-3.5.927,10.965,10.965,0,0,0-1.587.912,11.479,11.479,0,0,0-1.42,1.176,9.465,9.465,0,0,0-1.2,1.416c-.093.128-.171.256-.252.388l-.124.194-.1.206c-.07.14-.144.275-.206.419S1.45,7,1.388,7.139a11.1,11.1,0,0,0-.9,3.616,12.037,12.037,0,0,0,0,1.87,11.182,11.182,0,0,0,.283,1.843A9.738,9.738,0,0,0,2.284,17.82a10.261,10.261,0,0,0,1.183,1.4,9.606,9.606,0,0,0,1.408,1.16,11.674,11.674,0,0,0,3.294,1.54l.33.1-.008.365v.019c-.008.57.019,1.141.062,1.715q.035.425.081.861l.05.431c.016.136.043.268.062.4a9.034,9.034,0,0,0,1.261,3.069l.241.4-.384.252a20.49,20.49,0,0,0-3.989,3.5,22.645,22.645,0,0,0-3,4.4A20.643,20.643,0,0,0,.946,42.392c-.1.431-.178.865-.244,1.3s-.109.885-.147,1.331c-.081.9-.132,1.8-.14,2.7A26.762,26.762,0,0,0,.527,50.4a19.957,19.957,0,0,0,.442,2.627,14.128,14.128,0,0,0,2.1,4.811,12.209,12.209,0,0,0,1.626,1.9l.085.085c.178.163.361.322.543.481a11.351,11.351,0,0,0,1.106.823c.144.093.287.182.431.272.047.031.1.05.147.081a11.923,11.923,0,0,0,2.227.993,15.03,15.03,0,0,0,2.557.566l.338.043.066.338a22.628,22.628,0,0,0,1.273,4.435,14.636,14.636,0,0,0,2.312,3.911,8.344,8.344,0,0,0,1.637,1.482,6.379,6.379,0,0,0,1.987.881,7.047,7.047,0,0,0,2.177.163c.182-.023.38-.031.524-.062a1.352,1.352,0,0,0,.411-.144s.012,0,.015-.012a7.637,7.637,0,0,1-1.114-.047,6.738,6.738,0,0,1-1.948-.52,6.809,6.809,0,0,1-1.707-1.082,9.065,9.065,0,0,1-1.343-1.471A13.674,13.674,0,0,1,14.6,67.48a20.5,20.5,0,0,1-.939-3.768l-.089-.539.543-.008c.388-.012.776-.023,1.16-.046.19-.012.376-.027.566-.047s.38-.05.566-.078a18.6,18.6,0,0,0,2.254-.466,17.806,17.806,0,0,0,4.245-1.738,18.6,18.6,0,0,0,3.674-2.763c.283-.26.535-.551.8-.827.248-.291.512-.578.745-.885a17.445,17.445,0,0,0,1.323-1.9l.295-.493.279-.512.136-.256.128-.26.252-.524c.151-.357.318-.7.454-1.067l.206-.543.19-.543a19.7,19.7,0,0,0,.993-4.528,12.307,12.307,0,0,0-.369-4.54A8,8,0,0,0,29.8,37.31Zm0,0",
    transform: "translate(-0.414 -1.077)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M43,78H57.9v22.845H43Zm0,0",
    transform: "translate(-43 -78)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M55.553,79.587a13.252,13.252,0,0,0-1.276,1.362,17.709,17.709,0,0,0-1.1,1.513c-.3.454-.613.966-.966,1.6a25,25,0,0,0-1.54,3.414c-.05.132-.089.272-.136.4-.085.726-.194,1.416-.314,2.076.023-.012.05-.016.074-.027-.023.012-.05.019-.074.031h0a22.226,22.226,0,0,1-.958,3.62c0,.008-.008.023-.015.039-.035.093-.07.175-.1.26-.054.144-.113.295-.175.431a.989.989,0,0,1-.039.1c-.085.2-.178.392-.272.586-.023.047-.047.093-.066.14s-.058.1-.081.147c-.066.128-.132.252-.2.369-.027.047-.05.1-.081.144-.124.209-.248.407-.38.6-.167.241-.345.47-.532.695-.043.05-.081.1-.12.148-.163.19-.33.369-.5.543a.372.372,0,0,1-.07.066c-.058.062-.12.116-.182.178-.085.081-.171.159-.26.237-.027.019-.047.039-.074.058-.171.151-.353.3-.535.435a.783.783,0,0,1-.116.082c-.279.2-.566.388-.865.563.019.027.031.058.05.081-.015-.023-.043-.05-.054-.074a10.663,10.663,0,0,1-1.389.679,8.978,8.978,0,0,0,1,.745c.307-.081.609-.174.908-.271-.012-.031-.012-.062-.023-.089a.374.374,0,0,1,.027.085c.4-.128.784-.271,1.168-.43.147-.055.291-.117.435-.183s.307-.132.45-.2c.008,0,.012-.008.015-.008.213-.1.427-.2.632-.314.023-.012.043-.027.07-.039.144-.081.295-.163.438-.244.039-.023.082-.046.12-.066s.093-.054.144-.085.12-.078.182-.113c.093-.062.19-.12.287-.179s.179-.12.264-.178l.334-.229c.2-.14.388-.283.582-.431a17.477,17.477,0,0,0,6.216-9.665c.07-.279.136-.57.2-.869.027-.113.046-.225.07-.334.043-.186.078-.369.113-.566.031-.148.054-.3.085-.45s.05-.3.078-.458c.031-.19.058-.376.089-.566.012-.07.019-.147.031-.221.124-.838.229-1.715.314-2.642V82.07c.031-.33.062-.667.085-1v0c.05-.675.1-1.366.132-2.084.015-.3.027-.613.039-.927-.221.12-.442.241-.656.38A14.217,14.217,0,0,0,55.553,79.587Zm0,0",
    transform: "translate(-43.188 -78.051)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M50,61h8.94V71.926H50Zm0,0",
    transform: "translate(-50 -61)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M52.52,62.86l-.9.128c-.229.031-.462.062-.7.085v.737h.031l-.031,0v7.4a4.218,4.218,0,0,0,.481.07,8.718,8.718,0,0,0,2.056-.019,12.09,12.09,0,0,0,2.021-.4,5.153,5.153,0,0,0,1.835-.92,2.887,2.887,0,0,0,.644-.741c0-.272,0-.543,0-.811v-7.1A21.6,21.6,0,0,1,53.4,62.7Zm0,0",
    transform: "translate(-50.914 -61.285)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M50,71h7.946V81.926H50Zm0,0",
    transform: "translate(-50 -71)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_447",
    "data-name": "Path 447",
    d: "M56.85,71.7a10.811,10.811,0,0,1-1.812.632,16.692,16.692,0,0,1-1.886.376,11.564,11.564,0,0,1-1.913.151c-.1,0-.217,0-.322-.008v8.664c.019-.023.035-.054.054-.081a18.064,18.064,0,0,1,1.513-1.82,12.375,12.375,0,0,1,3.8-2.747,11.821,11.821,0,0,1,1.529-.578c.054-1.641.1-3.383.12-5.211-.082.054-.155.116-.244.175A8.63,8.63,0,0,1,56.85,71.7Zm0,0",
    transform: "translate(-50.918 -71.078)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M28.844,96H41.912v5.96H28.844Zm0,0",
    transform: "translate(-28.844 -96)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 13.906,
    height: 5.96,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M.844.719H13.2V5.965H.844Zm0,0",
    transform: "translate(-0.844 -0.719)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M.844,1H12.918V5.928H.844Zm0,0",
    transform: "translate(-0.844 -1)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M11.391,4.475c-.473-.113-3.577-1.2-4.532-1.618-.062-.027-.128-.058-.19-.081-.12-.058-.241-.109-.357-.159-.194-.085-.38-.171-.563-.252-.695-.31-1.292-.586-1.707-.729A4.938,4.938,0,0,0,2.494,1.34a1.711,1.711,0,0,0-.935.229A1.427,1.427,0,0,0,1,2.729C.918,4.265,3.138,4.859,4.469,5.072c.062.012.124.023.2.039.019,0,.035,0,.054.008.07.012.144.019.225.039h.012c.078.008.159.019.237.027a.486.486,0,0,0,.074.012c.085.012.178.019.272.035h.019c.093.012.19.019.279.031a.534.534,0,0,0,.078.012l.31.035h0c.1.012.213.019.322.035a.536.536,0,0,1,.078.012c.1.012.21.019.322.031.023,0,.043,0,.062,0,.089.012.178.016.268.027.035,0,.066,0,.1.008.109.012.213.023.318.031h.027c.1.012.2.019.3.027a.645.645,0,0,1,.085.012c.213.019.419.035.617.054.027,0,.047,0,.07,0,.2.016.384.035.555.047a.132.132,0,0,1,.039,0c.085.008.958.078.966.081.807,0,1.591-.039,2.355-.109a12.181,12.181,0,0,1-1.277-1.055Zm0,0",
    transform: "translate(-0.994 -1.34)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M43,43H65.845V61.872H43Zm0,0",
    transform: "translate(-43 -43)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M54.261,43.635c-4.5,0-8.016-.074-10.453-.221v.625a16.685,16.685,0,0,1,4.221.675,3.577,3.577,0,0,1,2.278,2.258,8.514,8.514,0,0,1,.4,1.851c.023.163.039.338.058.508.035.4.058.83.078,1.292,0,.209.008.427.012.644,0,.175.008.345.008.524v2.246a.366.366,0,0,0,.062-.016.3.3,0,0,1-.062.027v7.5a9.379,9.379,0,0,0,1.067-.167c.054-.015.113-.027.163-.047l.054-.016a16.916,16.916,0,0,0,3.356-.939,14.623,14.623,0,0,0,2.064-1.036c.124-.074.233-.163.349-.237v-4.73c-.008,0-.023,0-.035,0a.1.1,0,0,1,.035,0v-2.6a16.928,16.928,0,0,1,.427-4.4,4.314,4.314,0,0,1,.132-.411.261.261,0,0,1,.023-.058,4.146,4.146,0,0,1,.186-.419,4.562,4.562,0,0,1,.295-.481,3.632,3.632,0,0,1,1.777-1.3,17.12,17.12,0,0,1,4.221-.671V43.41C62.293,43.558,58.7,43.635,54.261,43.635Zm0,0",
    transform: "translate(-43.809 -43.41)",
    fill: "url(#linear-gradient)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(-6626.546 -6360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_15_21",
    "data-name": "Component 15 \\u2013 21",
    transform: "translate(6626.546 6360)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1059",
    "data-name": "Group 1059",
    transform: "translate(6.115)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1058",
    "data-name": "Group 1058",
    transform: "translate(0 -0.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1057",
    "data-name": "Group 1057",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1056",
    "data-name": "Group 1056",
    transform: "translate(0.039 0.954)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1050",
    "data-name": "Group 1050",
    transform: "translate(-0.039 -0.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1047",
    "data-name": "Group 1047",
    transform: "translate(0.244 0.993)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1046",
    "data-name": "Group 1046",
    transform: "translate(0.167 0.077)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M.41,1.074V74.348H32.533V1.074Zm0,0",
    transform: "translate(-0.414 -1.077)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1055",
    "data-name": "Group 1055",
    transform: "translate(-0.039 -0.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1054",
    "data-name": "Group 1054"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1053",
    "data-name": "Group 1053",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1052",
    "data-name": "Group 1052",
    transform: "translate(0.244 0.993)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1051",
    "data-name": "Group 1051",
    transform: "translate(0.167 0.077)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M.41,1.074V74.348H32.533V1.074Zm0,0",
    transform: "translate(-0.414 -1.077)",
    fill: "url(#linear-gradient)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1061",
    "data-name": "Group 1061",
    transform: "translate(14.061 36.79)",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1060",
    "data-name": "Group 1060",
    transform: "translate(0.186 0.05)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M43.188,78.051v22.775H57.671V78.051Zm0,0",
    transform: "translate(-43.188 -78.051)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1063",
    "data-name": "Group 1063",
    transform: "translate(21.014 19.904)",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1062",
    "data-name": "Group 1062",
    transform: "translate(0.908 0.283)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M50.914,61.285V71.354h7.042V61.285Zm0,0",
    transform: "translate(-50.914 -61.285)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1065",
    "data-name": "Group 1065",
    transform: "translate(21.014 29.837)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1064",
    "data-name": "Group 1064",
    transform: "translate(0.912 0.078)",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M50.918,71.078V81.515h7.019V71.078Zm0,0",
    transform: "translate(-50.918 -71.078)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1079",
    "data-name": "Group 1079",
    transform: "translate(0 54.669)",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1078",
    "data-name": "Group 1078",
    transform: "translate(-0.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1077",
    "data-name": "Group 1077",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1076",
    "data-name": "Group 1076",
    transform: "translate(0.838 0.714)",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1070",
    "data-name": "Group 1070",
    transform: "translate(-0.838 -0.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1069",
    "data-name": "Group 1069"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1068",
    "data-name": "Group 1068",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1067",
    "data-name": "Group 1067",
    transform: "translate(0.838 0.993)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1066",
    "data-name": "Group 1066",
    transform: "translate(0.149 0.338)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M.918,1.34V5.685h11.8V1.34Zm0,0",
    transform: "translate(-0.994 -1.34)",
    fill: "url(#linear-gradient)"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1075",
    "data-name": "Group 1075",
    transform: "translate(-0.838 -0.714)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1074",
    "data-name": "Group 1074"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1073",
    "data-name": "Group 1073",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1072",
    "data-name": "Group 1072",
    transform: "translate(0.838 0.993)",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1071",
    "data-name": "Group 1071",
    transform: "translate(0.149 0.338)",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M.918,1.34V5.685h11.8V1.34Zm0,0",
    transform: "translate(-0.994 -1.34)",
    fill: "url(#linear-gradient)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1081",
    "data-name": "Group 1081",
    transform: "translate(14.061 2.025)",
    clipPath: "url(#clip-path-25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1080",
    "data-name": "Group 1080",
    transform: "translate(0.803 0.407)",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M43.809,43.41V61.549H64.982V43.41Zm0,0",
    transform: "translate(-43.809 -43.41)",
    fill: "url(#linear-gradient)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/Logo-Footer.e860507ea79acfd4b10bd6911914d08a.svg";
export { ForwardRef as ReactComponent };